function matchSlideHeights() {
    const section = document.querySelector('.block-testimonial-standard');
    
    if (section) {
        const testimonials = section.querySelectorAll('.block-testimonial');
        let tallest = 0;

        testimonials.forEach((testimonial) => {
            testimonial.style.height = 'auto';
            if (testimonial.clientHeight > tallest) tallest = testimonial.clientHeight;
        });

        testimonials.forEach((testimonial) => {
            testimonial.style.height = tallest + 'px';
        });
    }
}
  
  // GLOBAL APP CONTROLLER
const controller = {
    init() {},
    loaded() {
        matchSlideHeights();
    },
    resized() {
        matchSlideHeights();
    },
    scrolled() {},
    keyDown() {},
    mouseUp() {},
};
export default controller;
  